import React from "react";
import { NavLink } from "react-router-dom";
import CardViewStates, { CardViewProps } from "./CardView.models";
import './CardView.scss';
export default class CardView extends React.PureComponent<CardViewProps, CardViewStates>{

    render(): React.ReactNode {
        let { config } = this.props;

        return <>
            <div className="card-view-area">
                <img src={config.imageSource} alt="card box icon" width={80} height={80}></img>
                <label className="title"> {config.title}</label>
                {this.buttonsView(config.showButton, config.buttonText,config.redirector)}
            </div>
        </>
    }

    buttonsView(showView: boolean, text: string,redirect:string) {
        let content;

        if (showView)
            content = <>
            <NavLink to={redirect}>
                <button className="btn btn-block btn-danger">{text === null || text === undefined ? 'مشاهده' : text}</button>
            </NavLink>
            </>;
        else
            content = <></>;

        return <>
            {content}
        </>;
    }
}